import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AISparkleIcon = ({
  color,
  title = "AI sparkle",
  ...props
}: IconProps) => (
  <Icon color={color} fill="none" title={title} viewBox="0 0 16 16" {...props}>
    <Path
      d="M5.87 2.04c.18-.54.94-.54 1.12 0l.74 2.22c.17.51.57.91 1.08 1.08l2.22.74c.54.18.54.94 0 1.12l-2.22.74c-.51.17-.91.57-1.08 1.08l-.74 2.22c-.18.54-.94.54-1.12 0l-.74-2.22a1.83 1.83 0 0 0-1.08-1.08L1.83 7.2c-.54-.18-.54-.94 0-1.12l2.22-.74c.51-.17.91-.57 1.08-1.08l.74-2.22Z"
      fill="currentColor"
    />
    <Path
      d="M11.92 1.24c.14-.43.75-.43.9 0l.35 1.03c.13.39.44.7.83.83l1.03.35c.43.14.43.75 0 .9L14 4.7c-.39.13-.7.44-.83.83l-.35 1.03c-.15.43-.76.43-.9 0l-.35-1.03a1.42 1.42 0 0 0-.83-.83l-1.03-.35c-.43-.15-.43-.76 0-.9l1.03-.35c.39-.13.7-.44.83-.83l.35-1.03Z"
      fill="currentColor"
    />
    <Path
      d="M11.42 10.07c.13-.38.67-.38.8 0l.27.82c.11.34.38.6.72.72l.82.27c.38.13.38.67 0 .8l-.82.27c-.34.12-.61.38-.72.72l-.27.82c-.13.38-.67.38-.8 0l-.27-.82a1.23 1.23 0 0 0-.72-.72l-.82-.27c-.38-.13-.38-.67 0-.8l.82-.27c.34-.12.61-.38.72-.72l.27-.82Z"
      fill="currentColor"
    />
  </Icon>
);
